import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'squirrel-footer',
    templateUrl: './squirrel-footer.component.html',
    styleUrls: ['./squirrel-footer.component.scss'],
    standalone: false
})
export class SquirrelFooterComponent implements OnInit {
  copyRightDate : Date = new Date();

  constructor() { }

  ngOnInit(): void {
  }

}
